<template>
    <div class='tep-pv-item-wrap'>
        <div class='tep-pv-item-wrap'>
            <div style='flex: 1'>
                <ai-form-number-box
                    :meta='{fieldNameText: meta.chField, title: props.meta.ch}'
                    :server-data='userData'
                    :read-only="metaChange?.readOnly"
                    :callbacks='{ userDataChanged: userChangedCh}'
                ></ai-form-number-box>
            </div>
            <div class="tep-pv-label"><span>&nbsp;[{{ meta.chM }}]&nbsp;</span></div>
        </div>
        <div class='tep-pv-item-wrap'>
            <div class="tep-pv-label"><span>&nbsp;с отклонением от&nbsp;</span></div>
            <div style='flex: 1'>
                <ai-form-number-box
                    :meta='{fieldNameText: meta.chFieldFrom}'
                    :server-data='userData'
                    :read-only="metaChange?.readOnly"
                    :callbacks='{ userDataChanged: userChanged}'
                ></ai-form-number-box>
            </div>
        </div>
        <div class='tep-pv-item-wrap'>
            <div class="tep-pv-label"><span>&nbsp;до&nbsp;</span></div>
            <div style='flex: 1'>
                <ai-form-number-box
                    :meta='{fieldNameText: meta.chFieldTo}'
                    :server-data='userData'
                    :read-only="metaChange?.readOnly"
                    :callbacks='{ userDataChanged: userChanged}'
                ></ai-form-number-box>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'tep-pv-characteristics'
};
</script>

<script setup>
import { inject, onMounted, ref } from 'vue';
import AiFormNumberBox from '@/components/card-component/ai-form-number-box.vue';

const userData = inject('userData');

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    serverData: {
        type: Object,
        default: () => {}
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});

const metaChange = ref(null);
const oldValChange = ref(null);

onMounted(() => {
    const kodHarp = props.serverData.kod_harp;
    metaChange.value = {...props.meta};
    if(kodHarp === null || kodHarp === 0) {
        if(props.meta.fieldNameText === 'tep-pv-characteristics-3' || props.meta.fieldNameText === 'tep-pv-characteristics-4') {
            metaChange.value = {...metaChange.value, readOnly: true}
        }
    } else if (kodHarp < 20) {
        if(props.meta.fieldNameText === 'tep-pv-characteristics-3') {
            metaChange.value = {...metaChange.value, readOnly: false}
        }
        if(props.meta.fieldNameText === 'tep-pv-characteristics-4') {
            metaChange.value = {...metaChange.value, readOnly: true}
        }
    } else if (kodHarp > 10) {
        if(props.meta.fieldNameText === 'tep-pv-characteristics-3' || props.meta.fieldNameText === 'tep-pv-characteristics-4') {
            metaChange.value = {...metaChange.value, readOnly: false}
        }
    }
    oldValChange.value = props.serverData[props.meta.chField];
})

const userChangedCh = () => {
    const field = props.meta.chField;
    const newVal = Number(userData.value[props.meta.chField]);
    if(oldValChange.value === newVal) {
        return;
    }
    if(field) {
        switch(field) {
            case 'p_pa':
                userData.value.pa_ot = newVal - newVal / 100 * 5;
                userData.value.pa_do = newVal + newVal / 100 * 5;
                userData.value.tsa = null;
                oldValChange.value = newVal;
                break;
            case 'p_ta':
                userData.value.ta_ot = Math.round(newVal - newVal / 100 * 5,0);
                userData.value.ta_do = Math.round(newVal + newVal / 100 * 5,0);
                userData.value.tsa = null;
                oldValChange.value = newVal;
                break;
            case 'p_p':
                userData.value.p_ot = newVal - newVal / 100 * 5;
                userData.value.p_do = newVal + newVal / 100 * 5;
                userData.value.ts = null;
                oldValChange.value = newVal;
                break;
            case 'p_t':
                userData.value.t_ot = newVal - newVal / 100 * 5;
                userData.value.t_do = newVal + newVal / 100 * 5;
                userData.value.ts = null;
                oldValChange.value = newVal;
                break;
            default:

                break;
        }
    }
    if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
}

const userChanged = () => {
     if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
}

</script>

<style scoped>
.tep-pv-item-wrap {
    display: flex;
    flex: 1;
}
.tep-pv-item-wrap :deep(.dx-field) {
    margin-right: 5px;
}
.tep-pv-label {
    color: rgba(117,117,117,.87);
    font-size: 13px;
    cursor: default;
    display: flex;
    align-items: center;
}
</style>
